import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import { en, es } from './translation'

Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: {
      navigation:{
        continue:"Continue",
        back:"Back",
        extras:"Extras Selected:",
        reservation:"MAKE RESERVATION",
      },
      coupon: {
        coupon:"Coupon",
        apply:"Apply",
        valid:"Valid Coupon!",
        invalid:"Invalid Coupon!",
        validFor:"Valid for:",
        passengers:"passengers",
      },
      search: {
        title:"What transportation do you need?",
        hotel:"Hotel",
        to:"to",
        airport:"Cancun Airport",
        transport:"Transportation",
        pointToPoint:"Place to Place",
        labelStarts:"Where your trip starts?",
        labelArrivalPickUp:"Pick Up: Cancun International Airport",
        labelDepartureDropOff:"Drop Off: Cancun International Airport",
        labelDestination:"Which is your destination?",

        dropOff:"Drop Off",
        passengers:"Passengers",
        adults:"Adults",
        kids:"Kids",
      },
      service:{
        loading:"Loading...",
        title:"Select Service",
        select:"SELECT:",
        oneWay:"ONE WAY",
        roundTrip:"ROUND TRIP",
        taxes:"*Taxes not included",
      },
      extras:{
        loading:"Loading...",
        title:"Extras",
        each:"ea.",
        taxes:"*Taxes included",
        first:"First trip:",
        second:"Second trip:",
      },
      info:{
        title:"Client information",
        firstName:"First Name",
        lastName:"Last Name",
        mail:"Email",
        phone:"Phone",

        arrivalInfo:"Arrival Information",
        date:"Date",
        hour:"Hour",
        minutes:"Minutes",
        labelFlight:"Flight hour as shown in your ticket.",
        flight:"Flight",
        airline:"Airline",

        departureInfo:"Departure Information",
        departureLabel:"Enter your flight data as shown in your ticket, the pickup is calculated automatically.",
        flightDate:"Flight Date",
        pickUpDate:"Pick Up Date",

        dropOff:"Drop Off",

        notes:"Notes and comments",
      },
      summary:{
        title:"Summary",
        origin:"Origin",
        destination:"Destination",
        adults:"Adults",
        kids:"Kids",
        serviceType:"Service Type",
        tripType:"Trip Type",
        coupon:"Coupon",

        schedules:"Schedules",
        clientData:"Client Data",
        name:"Name",
        email:"Email",
        phone:"Phone",
        notes:"Notes",

        totals:"Totals",
        loading:"Loading...",

        trip:"Trip",
        extras:"Extras",
        taxes:"Taxes",
        total:"Total",

        selectPayment:"Select your payment method",
        choosePayment:"Please choose payment method",

        arrival:"Arrival",
        departure:"Departure",
        pickup:"Pick up",

      },
      dateInfo:{
        from:"From",
        to:"To",
        airport:"Cancun Airport",
        flightDate:"Flight Date",
        flightTime:"Flight Time",
        flight:"Flight",
        airline:"Airline",
        date:"date",
        time:"time",
        pickUpDate:"Pick Up Date",
        pickUpTime:"Pick Up Time",
        extras:"Extras Selected",
      },
      success:{
        thankYou:'Thank you!',
        message:'Your book has been scheduled. We have sent you an email to',
        message2:'with all the details!',
        newReservation:'NEW RESERVATION',
        viewVoucher:'VIEW VOUCHER',
      },
    },
    es: {
      navigation:{
        continue:"Continuar",
        back:"Atras",
        extras:"Extras:",
        reservation:"CREAR RESERVACION",
      },
      coupon: {
        coupon:"Cupón",
        apply:"Aplicar",
        valid:"¡Cupón Válido!",
        invalid:"Cupón Inválido",
        validFor:"Valido para:",
        passengers:"pasajeros",
      },
      search: {
        title:"¿Qué tipo de transportación necesitas?",
        hotel:"Hotel",
        to:"A",
        airport:"Aeropuerto de Cancún",
        transport:"Transportación",
        pointToPoint:"Punto a Punto",
        labelStarts:"¿Dónde comienza tu viaje?",
        labelDepartureDropOff:"Destino: Cancún International Airport",
        labelArrivalPickUp:"Pick Up: Cancún International Airport",
        labelDestination:"¿Cual es tu destino?",

        dropOff:"Destino",
        passengers:"Pasajeros",
        adults:"Adultos",
        kids:"Niños",
      },
      service:{
        loading:"Cargando...",
        title:"Seleccionar Servicio",
        select:"SELECCIONAR:",
        oneWay:"VIAJE DE IDA",
        roundTrip:"VIAJE REDONDO",
        taxes:"*Impuestos no incluidos",
      },
      extras:{
        loading:"Cargando...",
        title:"Extras",
        each:"c/u",
        taxes:"*Impuestos Incluidos",
        first:"Primer Viaje:",
        second:"Segundo Viaje:",
      },
      info:{
        title:"Información del Cliente",
        firstName:"Nombre",
        lastName:"Apellido",
        mail:"Email",
        phone:"Teléfono",

        arrivalInfo:"Información de Llegada",
        date:"Fecha",
        hour:"Hora",
        minutes:"Minutos",
        labelFlight:"La hora del vuelo como se muestra en su boleto.",
        flight:"Vuelo",
        airline:"Aerolinea",

        departureInfo:"Información de Salida",
        departureLabel:"Introduzca sus datos como aparece en su boleto, el pick up se calcula automaticamente.",
        flightDate:"Fecha de vuelo",
        pickUpDate:"Fecha de Pick Up",

        dropOff:"Destino",

        notes:"Notas y Comentarios.",
      },
      summary:{
        title:"Resumen",
        origin:"Origen",
        destination:"Destino",
        adults:"Adultos",
        kids:"Niños",
        serviceType:"Tipo de Servicio",
        tripType:"Tipo de Viaje",
        coupon:"Cupón",

        schedules:"Horarios",
        clientData:"Datos de Cliente",
        name:"Nombre",
        email:"Email",
        phone:"Teléfono",
        notes:"Notas",

        totals:"Total",
        loading:"Cargando...",

        trip:"Viaje",
        extras:"Extras",
        taxes:"Impuestos",
        total:"Total",

        selectPayment:"Seleccione un método de pago",
        choosePayment:"Por favor, Seleccionar un método de pago.",
        arrival:"Llegada",
        departure:"Salida",
        pickup:"Pick up",

      },
      success:{
        thankYou:'Gracias!',
        message:'Tu reserva ha sido agendada, enviamos un correo a',
        message2:'con todos los detalles',
        newReservation:'NUEVA RESERVA',
        viewVoucher:'VER VOUCHER',
      },
      dateInfo:{
        from:"Origen",
        to:"Destino",
        airport:"Aeropuerto de Cancún",
        flightDate:"Fecha de Vuelo",
        flightTime:"Hora de Vuelo",
        flight:"Vuelo",
        airline:"Aerolinea",
        date:"Fecha",
        time:"Hora",
        pickUpDate:"Fecha de Pick Up",
        pickUpTime:"Hora de Pick Up",
        extras:"Extras Seleccionados",
      }
    }
  }
})
